const useLogoUrlReplacement = () => {
  const replacementOfUrl = ({ url }) => {
    if (url) {
      const urlObject = new URL(url);
      const searchParams = new URLSearchParams(urlObject?.search);
      searchParams.set('token', process.env.NEXT_PUBLIC_LOGO_DOT_DEV_TOKEN);
      searchParams.set('fallback', '404');
      searchParams.delete('size');
      if (url?.toLowerCase()?.startsWith('https://img.logo.dev')) {
        return `${urlObject?.origin}/${normalizeUrl(urlObject?.pathname)}?${searchParams?.toString()}`;
      } else {
        return url;
      }
    }
  };

  const normalizeUrl = (url) => {
    url = url.trim();
    url = url.replace(/^\//, '');
    url = url.replace(/^https?:\/\//i, '');
    url = url.replace(/\/$/, '');
    return url;
  };
  return { replacementOfUrl, normalizeUrl };
};

export default useLogoUrlReplacement;
